<template>
  <v-app id="inspire" class="bodyPadding">
    <mo-header></mo-header>
    <div id="qtePopup">
      <div id="qtePopupHeader">
        <div id="qtePopupHeader-Container">
          <a href="#" @click.prevent="fncGoLite()" id="qtePopupClose">
            All Quotes
          </a>
          <span id="qtePopupQteNumber">{{ quoteSingle.quote.quote_no }} - Quote Details</span>
          </div>


      </div>

      <div id="qtePopupContent">

        <div class="row icons">
          <div>
            <button id="editQuote" v-if="objAuthorize.manufacturer == '385889803' && quoteSingle.quote.hide_quote_edit == true" @click="fncEditQuote" class="primary-icon-btn">Edit<br>Quote</button>
            <button id="openCalculator" v-if="objAuthorize.manufacturer == '385889803' && quoteSingle.quote.totalFullPrice == '0' && quoteSingle.quote.calculator_links != '' && quoteSingle.quote.calculator_links != 'null' && quoteSingle.quote.calculator_links != null" @click="fncOpenCalculator()" class="primary-icon-btn">Open<br>Calculator</button>
            <button id="viewQuote" @click="fncViewQuote()" class="primary-icon-btn">View<br>Quote</button>
            <button v-if="quoteSingle.quote.totalFullPrice != '0'" id="downloadQuote" @click="fncDownloadQuote()" class="primary-icon-btn">Download<br>Quote</button>

            <button id="notificationHistory" @click="fncNotificationHistory" class="primary-icon-btn">Notification<br>History</button>
            <button id="attachments" v-if="quoteSingle.quote.hasAttachment == '' || quoteSingle.quote.hasAttachment == 'null' || quoteSingle.quote.hasAttachment == null" @click="fncQuoteAttachments()" class="primary-icon-btn">Supporting<br>Documents</button>
            <button id="attachments" v-else @click="fncQuoteAttachments()" class="primary-icon-btn"><i class="material-icons attachmentTick">done</i>Supporting<br>Documents</button>
            <button id="linkedUsers" v-if="objAuthorize.manufacturer == '385889803'" @click="fncSetResponsibleReps( quoteSingle.quote, 0 )" class="primary-icon-btn">Linked<br>Users</button>
            <button id="cloneQuote" v-if="objAuthorize.manufacturer == '385889803'" @click="fncCloneQuote()" class="primary-icon-btn">Clone<br>Quote</button>
            <button id="archiveQuote" v-if='objAuthorize.privileges.indexOf("CAN_ARCHIVE") != -1' @click="fncArchiveQuote()" class="primary-icon-btn">Archive<br>Quote</button>

          </div>
          <div>
            <button v-if="quoteSingle.checkedOut == true && quoteSingle.quote.totalFullPrice != '0'" id="deliveryNote" @click="fncGenerateDeliveryNote()" class="primary-icon-btn">Download<br>Delivery Note</button>
            <button v-if="objAuthorize.manufacturer == '385889803'" id="apiDetails" @click="fncApiDetails()" class="primary-icon-btn">API<br>Details</button>
          </div>
        </div>

        <div class="row">
          <div class="item row">
            <div id="section-Department" class="item">
              <span class="itemHeader">Department</span>
              <span v-if="quoteSingle.quote.department_name != '' && quoteSingle.quote.department_name != 'null' && quoteSingle.quote.department_name != null" class="itemData">{{ quoteSingle.quote.department_name }}</span>
              <span v-else class="itemData">Not Set</span>
            </div>
            <div id="section-Total" class="item" >
              <span class="itemHeader">Total Excl VAT</span>
              <span class="itemData">R{{ quoteSingle.quote.vatPrice.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }}</span>
            </div>
            <div v-if="objAuthorize.manufacturer == '385889803'" id="section-PONumber" class="item">
              <span class="itemHeader">PO Number</span>
              <span class="itemData" v-html="fncFormatPo(quoteSingle.quote.purchase_order_numbers)"></span>
            </div>
            <div v-if="objAuthorize.manufacturer == '385889803'" id="section-SONumber" class="item" >
              <span class="itemHeader">SO Number</span>
              <span class="itemData">{{ quoteSingle.quote.sales_order_number }}</span>
            </div>
            <!-- Hide Order number until manage columns is implemented -->
            <div id="section-orderNumber" class="item" style="display: none">
              <span class="itemHeader">Order Number</span>
              <span class="itemData">{{ quoteSingle.quote.order_no }}</span>
            </div>
          </div>
          <div id="section-Status" class="item" >
            <span class="itemHeader">Current Status</span>
            <span class="itemData" :id="fncSetId(quoteSingle.quote.id)">{{ quoteSingle.quote.quoteStatus }}</span>
            <button id="updateStatus" v-if="objAuthorize.privileges.indexOf('CANNOT_UPDATE_STATUS') == -1"  @click="fncEditStatusPopup()" class="primary-btn">Update Status</button><br>
            <!--<button id="processOrder" class="primary-btn">Process Order</button>-->
          </div>
        </div>
        <div class="container">
          <div class="card-columns">
            <div id="section-quoteDetails" class="card p-3">

              <div class="sectionHeader">QUOTE DETAILS</div>

              <table>
                <tr id="item-creationDate">
                  <td><span class="itemHeader">Creation Date:</span></td>
                  <td colspan="3"><span class="itemData">{{ quoteSingle.quote.quoteCreated }}</span></td>
                </tr>
                <tr id="item-quoteAge">
                  <td><span class="itemHeader">Quote Age:</span></td>
                  <td colspan="3"><span class="itemData">{{ quoteSingle.quote.age }} days</span></td>
                </tr>
                <tr class="seperator" v-if="objAuthorize.manufacturer == '385889803'">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>
                <tr id="item-quoteType" v-if="objAuthorize.manufacturer == '385889803'">
                  <td><span class="itemHeader">Quote Created with:</span></td>
                  <td colspan="3"><span class="itemData">{{ quoteSingle.quote.quote_type }}</span></td>
                </tr>
                <tr id="item-calculator" v-if="objAuthorize.manufacturer == '385889803' && quoteSingle.quote.calc_type != 'Lookup Service' && quoteSingle.quote.calc_type != 'Service Form' && quoteSingle.quote.calc_type != 'Service Type'">
                  <td><span class="itemHeader">Calculator used:</span></td>
                  <td colspan="3"><span class="itemData">{{ quoteSingle.quote.calc_type }}</span></td>
                </tr>
                <tr id="item-serviceType" v-if="objAuthorize.manufacturer == '385889803'">
                  <td><span class="itemHeader">Service Type:</span></td>
                  <td><span class="itemData" v-html="fncServiceType()"></span></td>
                  <td v-if="quoteSingle.quote.calc_type == 'Service Form'"><a @click="fncEditSurveyDoc()" id="editServiceForm" class="secondary-link">Edit Form</a></td>
                  <td v-else></td>
                  <td v-if="quoteSingle.quote.calc_type == 'Service Form'"><a @click="fncDownloadSurveyDoc()" id="downloadServiceForm" class="secondary-link">Download Form</a></td>
                  <td v-else></td>
                </tr>
                <tr v-if="objAuthorize.manufacturer == '385889803'" id="item-surveyType">
                  <td><span class="itemHeader">Engagement Type:</span></td>
                  <td colspan="3"><span class="itemData" v-html="fncGetSurveyType()"></span></td>
                </tr>
                <tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>
                <!--<tr id="item-kamRegion">
                  <td><span class="itemHeader">Kam Region:</span></td>
                  <td colspan="3"><span class="itemData">{Kam Region}</span></td>
                </tr>
                <tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>-->
                <tr id="item-originator">
                  <td><span class="itemHeader">Originator:</span></td>
                  <td colspan="3"><a href="#" @click="fncShowOriginator()" class=" link itemData">{{ quoteSingle.quote.name }} {{ quoteSingle.quote.surname }}</a></td>
                </tr>
                <tr id="item-originatorType">
                  <td><span class="itemHeader">Originator Type:</span></td>
                  <td colspan="3"><span class="itemData">{{ quoteSingle.quote.userType }}</span></td>
                </tr>
                <tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>
                <tr id="item-linkedQuotes" v-if="objAuthorize.manufacturer == '385889803'">
                  <td><span class="itemHeader">Linked Quotes:</span></td>
                  <td colspan="3" v-if="quoteSingle.quote.linked_quotes == 'None'">None</td>
                  <td colspan="3" v-html="fncShowLinkedQuotes()" v-else></td>
                </tr>                
                <tr v-if="quoteSingle.quote.external_ref != '' && quoteSingle.quote.external_ref != null && quoteSingle.quote.external_ref != 'null'" id="item-companyName">
                  <td><span class="itemHeader">External Reference:</span></td>
                  <td><span class="itemData">{{ quoteSingle.quote.external_ref }}</span></td>
                </tr>
              </table>

            </div>
            <div id="section-customerDetails" class="card p-3">

              <div class="sectionHeader">CUSTOMER DETAILS</div>

              <table>
                <tr id="item-customerName">
                  <td><span class="itemHeader">Name:</span></td>
                  <td v-if="quoteSingle.customer.length > 0"><a @click="fncShowCustomer()" class="itemData link">{{ quoteSingle.customer[0].name }} {{ quoteSingle.customer[0].surname }}</a></td>
                  <td v-else><span class="itemData link">No customer has been set</span></td>
                </tr>
                <tr v-if="quoteSingle.customer.length > 0" id="item-customerEmail">
                  <td><span class="itemHeader">Email:</span></td>
                  <td><span class="itemData">{{ quoteSingle.customer[0].email }}</span></td>
                </tr>
                <tr v-if="quoteSingle.customer.length > 0"  id="item-customerTelephone">
                  <td><span class="itemHeader">Telephone:</span></td>
                  <td><span class="itemData">{{ quoteSingle.customer[0].contactnum }}</span></td>
                </tr>
                <tr v-if="quoteSingle.customer.length > 0" id="item-companyName">
                  <td><span class="itemHeader">Company:</span></td>
                  <td><span class="itemData">{{ quoteSingle.customer[0].companyName }}</span></td>
                </tr>
                <tr v-if="quoteSingle.quote.memo != ''" id="item-companyName">
                  <td><span class="itemHeader">Memo:</span></td>
                  <td><span class="itemData">{{ quoteSingle.quote.memo }}</span></td>
                </tr>                
                <!--<tr id="item-companyRegion">
                  <td><span class="itemHeader">Region:</span></td>
                  <td><span class="itemData">{Region}</span></td>
                </tr>-->
<!--                <tr class="seperator">-->
<!--                  <td colspan="2"><div class="seperator-line"></div></td>-->
<!--                </tr>-->
                <!--<tr id="item-customerManager">
                  <td><span class="itemHeader">Customer Manager:</span></td>
                  <td><span class="itemData">{Customer Manager}</span></td>
                </tr>
                <tr id="item-customerType">
                  <td><span class="itemHeader">Customer Type:</span></td>
                  <td><span class="itemData">{Customer Type}</span></td>
                </tr>
                <tr id="item-specifier">
                  <td><span class="itemHeader">Specifier:</span></td>
                  <td><span class="itemData">{Specifier}</span></td>
                </tr>
                <tr class="seperator">
                  <td colspan="2"><div class="seperator-line"></div></td>
                </tr>-->
                <!-- Hide delivery method until manage columns is implemented -->
                <tr id="item-deliveryMethod" style="display:none">
                  <td><span class="itemHeader">Delivery Method:</span></td>
                  <td colspan="3"><span class="itemData">{{ quoteSingle.quote.delivery_method }}</span></td>
                </tr>
<!--                <tr class="seperator">-->
<!--                  <td colspan="2"><div class="seperator-line"></div></td>-->
<!--                </tr>-->

                <!--<tr id="item-project">
                  <td><span class="itemHeader">Project:</span></td>
                  <td colspan="3"><span class="itemData">{Project}</span></td>
                </tr>
                <tr id="item-projectAddress">
                  <td><span class="itemHeader">Project Address:</span></td>
                  <td colspan="3"><span class="itemData">{Project Address}</span></td>
                </tr>
                <tr id="item-projectRegion">
                  <td><span class="itemHeader">Project Region:</span></td>
                  <td colspan="3"><span class="itemData">{Project Region}</span></td>
                </tr>
                <tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>-->
              </table>
            </div>

            <div id="section-recipients" class="card p-3" v-if="objAuthorize.manufacturer == '385889803'">
              <div class="sectionHeader">ADDITIONAL NOTIFICATION RECIPIENTS
                <div class="sectionSubHeader">Notifications for this quote will also be sent to the below non-MyOrder recipients.</div></div>


              <table>
                <tr class="item-customerRecipientValue">
                  <td><span class="itemHeader">Customer Recipient:</span></td>
                  <td><div style="display: flex; align-items: center; justify-content: space-around">
                    <a v-if="quoteSingle.quote.customer_recipient != ''" v-html="fncFormatHtml(quoteSingle.quote.customer_recipient)"></a>
                    <a class="itemData" v-else>Not Set</a>
                    <v-btn style="float: right;" class="elevation-5" @click="fncEditCustomerRecipient()" color="info">ADD</v-btn>
                    <!--<a class="itemData link">{Customer Recipient}</a>-->
                  </div></td>
                </tr>
                <tr class="seperator">
                  <td colspan="2"><div class="seperator-line"></div></td>
                </tr>
                <tr class="item-vendorRecipientValue">
                  <td><span class="itemHeader">Vendor Recipient:</span></td>
                  <td><div style="display: flex; align-items: center; justify-content: space-around">
                  <a v-if="quoteSingle.quote.vendor_recipient != ''" v-html="fncFormatHtml(quoteSingle.quote.vendor_recipient)"></a>
                  <a class="itemData" v-else>Not Set</a>
                  <v-btn style="float: right;" class="elevation-5" @click="fncEditVendorRecipient()" color="info">ADD</v-btn>
                  </div></td>
                </tr>
              </table>
            </div>


            <div id="section-statusHistory" class="card p-3">
              <div class="sectionHeader">STATUS HISTORY</div>

              <table>
                <tr class="item-previousStatus">
                  <td><span class="itemHeader">Previous Status:</span></td>
                  <td><span class="itemData">{{ quoteSingle.audits[0].prev_value }}</span></td>
                </tr>
                <tr class="item-statusComment">
                  <td><span class="itemHeader">Comment:</span></td>
                  <td><span class="itemData">{{ quoteSingle.audits[0].data }}</span></td>
                </tr>
                <tr class="item-statusDateChanged">
                  <td><span class="itemHeader">Date Changed:</span></td>
                  <td><span class="itemData">{{ quoteSingle.audits[0].timsetamp }}</span></td>
                </tr>
                <tr class="item-statusChangedBy">
                  <td><span class="itemHeader">Changed By:</span></td>
                  <td><span class="itemData">{{ quoteSingle.audits[0].changed_by }}</span></td>
                </tr>
                <tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>
                <tr>
                  <td colspan="2"> <a class="viewAllStatusHistory secondary-link" @click="fncViewStatusHistory()">View all status changes</a></td>
                </tr>
                <tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>
                <tr class="item-statusCancelReason">
                  <td><span class="itemHeader">Cancellation Reason:</span></td>
                  <td><span class="itemData" v-html="fncGetDescription('fs_job_cancelled')"></span></td>
                </tr>
                <tr class="item-statusRejectReason">
                  <td><span class="itemHeader">Reject Reason:</span></td>
                  <td><span class="itemData" v-html="fncGetDescription('is_rejected')"></span></td>
                </tr>
              </table>
            </div>
            <div v-if="objAuthorize.manufacturer == '385889803'" id="section-vendor" class="card p-3">
              <div class="sectionHeader">VENDOR</div>
              <table>
                <tr class="item-store">
                  <td><span class="itemData">{{ quoteSingle.quote.vendor_name }}</span></td>
                </tr>

              </table>
            </div>

            <div id="section-store" class="card p-3">
              <!-- these are the columns the user creates for their own views from the manage columns page -->
              <div class="sectionHeader">STORE</div>

              <table>
                <tr class="item-store">
                  <td v-if="quoteSingle.quoteItems[0].name != '' && quoteSingle.quoteItems[0].name != 'null' && quoteSingle.quoteItems[0].name != null"><span class="itemData">{{ quoteSingle.quoteItems[0].name }}</span></td>
                  <td v-else><span class="itemData">Not Set</span></td>
                  <td v-if="objAuthorize.manufacturer == '385889803'"><a id="changeStore" @click.prevent="fncUpdateStore()" v-if="objAuthorize.privileges.indexOf('CAN_UPDATE_STORE') != -1 && objAuthorize.manufacturer == '385889803'" class="secondary-link">Change Store</a></td>
                  <td v-if="objAuthorize.manufacturer == '385889803'"><a id="changeAudit" @click.prevent="fncStoreAudits()" v-if="objAuthorize.manufacturer == '385889803'" href="#" class="secondary-link">Store Audit</a></td>
                </tr>

              </table>
            </div>
            <div id="section-manufacturerDate" class="card p-3" v-if="objAuthorize.manufacturer == '385889803'">
              <div>
                <span class="itemHeader">Manufacture Date:</span>
                <span class="itemData"><date-picker class="quoteDateRep dashDateRep" valueType="format" @change="fncUpdateDate('manufacturer' )" v-model="quoteSingle.quote.manufacturer_date_api" placeholder="Manufacturer Date" format="YYYY-MM-DD" lang="en"></date-picker></span>
              </div>
              <div>
                <span class="itemHeader">Delivery Date:</span>
                <span class="itemData"><date-picker class="quoteDateRep dashDateRep" valueType="format" @change="fncUpdateDate('delivery' )" v-model="quoteSingle.quote.delivery_date_api" placeholder="Delivery Date" format="YYYY-MM-DD" lang="en"></date-picker></span>
              </div>
            </div>

            <div id="section-roleSpecific" class="card p-3">
              <!-- these are the columns the user creates for their own views from the manage columns page -->
              <div class="sectionHeader">ROLE SPECIFIC</div>
              <p v-if="quoteSingle.quoteReps.length == 0">No one has been linked to this quote.</p>
              <table>
                <tr v-for="(v, k) in quoteSingle.quoteReps" class="item-roleSpecific">
                  <td><span class="itemHeader">{{ v.roleName }}</span></td>
                  <td>
                    <a v-if="objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1" @click="fncSetResponsibleReps( quoteSingle.quote, 0 )" class="itemData link">{{ v.name }} {{ v.surname }}</a>
                    <span v-else class="itemData">{{ v.name }} {{ v.surname }}</span>
                  </td>
                </tr>
              </table>
            </div>


            <!-- Hide discounts until manage columns is implemented -->
            <div id="section-discount" class="card p-3" style="display: none">
              <div class="sectionHeader">DISCOUNT</div>

              <table>
                <tr class="item-prediscountValue">
                  <td><span class="itemHeader">Pre-discount Value:</span></td>
                  <td><span class="itemData">R{{ quoteSingle.quote.totalPrice.toFixed(2) }}</span></td>
                </tr>
                <tr class="item-discountValue">
                  <td><span class="itemHeader">Discount Value:</span></td>
                  <td><span class="itemData">R{{ quoteSingle.quote.totalDiscount.toFixed(2) }}</span></td>
                </tr>
                <tr class="item-discount%">
                  <td><span class="itemHeader">Discount %:</span></td>
                  <td><span class="itemData">{{ quoteSingle.quote.discountPercentage }}</span></td>
                </tr>
              </table>
            </div>

            <div id="section-installation" class="card p-3" v-if="quoteSingle.quote.installation == true">
              <div class="sectionHeader">INSTALLATION</div>

              <table>
                <tr class="item-lookupRef">
                  <td><span class="itemHeader">Lookup Service Ref:</span></td>
                  <td><span class="itemData link">{{ quoteSingle.quote.installation_lookup_ref }}</span></td>
                </tr>
                <tr class="item-installationDate">
                  <td><span class="itemHeader">Installation Date:</span></td>
                  <td><span class="itemData link">{{ quoteSingle.quote.installation_date }}</span></td>
                </tr>
                <tr class="item-installationTime">
                  <td><span class="itemHeader">Installation Time:</span></td>
                  <td><span class="itemData link">{{ quoteSingle.quote.installation_time }}</span></td>
                </tr>
                <tr class="item-onsiteTime" style="display: none">
                  <td><span class="itemHeader">Onsite Time</span></td>
                  <td><span class="itemData" v-html="fncGetDescription('fs_on_site')"></span></td>
                </tr>
                <tr class="item-jobCompleteDate" style="display: none">
                  <td><span class="itemHeader">Job Complete Date</span></td>
                  <td><span class="itemData" v-html="fncGetDescription('fs_job_complete')"></span></td>
                </tr>
                <!--<tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>
                <tr class="item-appointmentDateValue">
                  <td><span class="itemHeader">Appointment Date:</span></td>
                  <td><a class="itemData link">{Appointment Date}</a></td>
                </tr>
                <tr class="item-appointmentTimeValue">
                  <td><span class="itemHeader">Appointment Time:</span></td>
                  <td><a class="itemData link">{Appointment Time}</a></td>
                </tr>-->
                <tr class="seperator">
                  <td colspan="4"><div class="seperator-line"></div></td>
                </tr>
                <tr>
                  <!-- Open view quote popup as this is where the installation details are displayed -->
                  <td colspan="2"><a @click="fncViewQuote()" id="viewInstallationQuote" class="secondary-link">View Details</a></td>
                </tr>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';
  import DatePicker from 'vue2-datepicker';
  import router from '@/router';

  export default {
    name: 'QuoteContent',
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'quoteLiteContentClick',
        'quoteSingle',
        'branchList',
        'repUsers',
        'statusList',
        'quoteLiteContentLoaded'
      ])
    },
    methods: {
      fncFormatPo( poNumbers ) {

        var input = poNumbers; 

        let count = 0;

        const output = input.replace(/,/g, () => {
            count++;
            return count % 2 === 0 ? "<br />" : ",";
        });

        return output;

      },
      fncGoLite() {

        // this.$router.replace('/reports/quote-reports-lite');

        this.$router.replace('/reports/quote-reports-lite').then(() => {
          //console.log('Spasie');
        });

        // window.location = 'https://myorder.ndtec.local/#/reports/quote-reports-lite?reload=true';

        /*this.$store.commit('fncEmptyLiteColumns', []);
        this.$store.commit('fncSetQuoteLiteLoaded', false);
        this.$router.replace('/reports/quote-reports-lite');*/

        /*this.$store.commit('fncSetQuoteLiteLoaded', false);

        this.$router.push({path: '/reports/quote-reports-lite', query: {p: 1}});
        this.$router.go();*/

        //this.$router.go(-1);

        /*window.history.go(-1); // Navigate back in browser history
        window.location.reload(); // Immediately reload the page*/

        /*setTimeout(() => {
          window.location.reload();
        }, 1);*/

        //this.$router.replace('/reports/quote-reports-lite');
      },
      fncSetId( id ) {
        return id;
      },
      fncShowLinkedQuotes() {
        var objReturn = [];

        var setUrl = window.location.protocol + process.env.API_ENDPOINT;
            setUrl = setUrl.replace('Handlers','');

        setUrl = setUrl + '#/quote-single-content?quote=';

        for( var l in this.quoteSingle.quote.linked_quotes ) {
          objReturn.push('<a data-v-29f95ba2 href="'+setUrl + this.quoteSingle.quote.linked_quotes[l].id+'" target="_blank" class="link itemData">'+this.quoteSingle.quote.linked_quotes[l].quote_no+'</a>');
        }

        return objReturn.join(' ');
      },
      fncGetStatusDropdown( objItem, quoteId) {

        var currentStatus = objItem.status;
        var currentStatusOrder = -1;

        if( this.objAuthorize.department_active == 0 || this.objAuthorize.department_status_share == 1 ) {
          // return status as per normal
          var canBack = false;
          var canForward = false;
          var isChecked = false;

          var newFilterStatus = [];
          for( var f in this.filterStatusSet ) {
            this.filterStatusSet[f].disabled = false;
            newFilterStatus.push( this.filterStatusSet[f] );
          }

          for( var f in newFilterStatus ) {
            if( newFilterStatus[f].description == currentStatus ) {
              currentStatusOrder = f;
            }
            if( newFilterStatus[f].can_back_after_payment == 'Yes' ) {
              canBack = f;
            }
            if( newFilterStatus[f].is_checked == 'Yes' ) {
              isChecked = f;
            }
            if( newFilterStatus[f].can_forward_before_payment == 'Yes' ) {
              canForward = f;
            }
          }

          var finalS = [];

          if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {
            for (var f in newFilterStatus) {
              if( parseInt(currentStatusOrder) < parseInt(isChecked) && parseInt(f) < parseInt(isChecked) ) {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
              } else if( parseInt(currentStatusOrder) >= parseInt(isChecked) && parseInt(f) >= parseInt(isChecked) ) {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
              } else {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
              }
            }
            //return finalS;
          } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') != -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 ) {
            finalS = newFilterStatus;
            //return newFilterStatus;
          } else if( canBack != false || canForward != false ) {
            if( canBack != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 /*&& currentStatusOrder > isChecked*/ ) {
              for (var f in newFilterStatus) {
                if ( parseInt(f) < parseInt(canBack) && parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                } else if ( parseInt(f) < parseInt(isChecked) && parseInt(currentStatusOrder) <= parseInt(isChecked)) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else if ( parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 && parseInt(currentStatusOrder) <= parseInt(isChecked)  ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                }
              }
            }
            if( canForward != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {
              for( var f in newFilterStatus ) {
                if( parseInt(f) >= parseInt(canForward) && parseInt(currentStatusOrder) <= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                }
              }
            }
            //return finalS;
          } else {
            finalS = newFilterStatus
            //return newFilterStatus;
          }

        } else {

          var returnDepartment = objItem.department;
          var departmentName = objItem.department_name;
          var theDepartment = '';
          // now that we have the department id we can display the correct statuses
          var returnStatuses = [];
          var loggedRole =  this.objAuthorize.roles[0];

          // return status as per normal
          var canBack = false;
          var canForward = false;
          var isChecked = false;

          for( var s in this.filterStatus ) {
            var statusRoles = this.filterStatus[s].roles != null ? this.filterStatus[s].roles.split(',') : [];
            if( this.filterStatus[s].department != null ) {
              var objDepartments = this.filterStatus[s].department.split(',');
            } else {
              var objDepartments = [];
            }

            if( theDepartment == '' ) {
              returnDepartment = 0;
            } else {
              returnDepartment = returnDepartment;
            }

            returnDepartment = objItem.departmentId;

            // if( returnDepartment == this.filterStatus[s].department && ( statusRoles.indexOf( loggedRole ) != -1 || this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1 ) ) {
            if( objDepartments.indexOf(String(returnDepartment)) != -1 && ( statusRoles.indexOf( loggedRole ) != -1 || this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1 ) ) {
              returnStatuses.push( this.filterStatus[s] );
            }

            if( returnDepartment == 0 && objDepartments.length == 0) {
              returnStatuses.push( this.filterStatus[s] );
            }

            if( this.filterStatus[s].description == currentStatus ) {
              currentStatusOrder = this.filterStatus[s].order;
            }

            if( this.filterStatus[s].can_back_after_payment == 'Yes' ) {
              canBack = this.filterStatus[s].order;
            }
            if( this.filterStatus[s].is_checked == 'Yes' ) {
              isChecked = this.filterStatus[s].order;
            }
            if( this.filterStatus[s].can_forward_before_payment == 'Yes' ) {
              canForward = this.filterStatus[s].order;
            }

          }

          /* ------------------ */

          var newFilterStatus = [];
          for( var f in returnStatuses ) {
            returnStatuses[f].disabled = false;
            newFilterStatus.push(returnStatuses[f]);
          }

          for( var f in newFilterStatus ) {
            /*if( newFilterStatus[f].description == currentStatus ) {
              currentStatusOrder = f;
            }*/
            /*if( newFilterStatus[f].can_back_after_payment == 'Yes' ) {
              canBack = newFilterStatus[f].order;
            }
            if( newFilterStatus[f].is_checked == 'Yes' ) {
              isChecked = newFilterStatus[f].order;
            }
            if( newFilterStatus[f].can_forward_before_payment == 'Yes' ) {
              canForward = newFilterStatus[f].order;
            }*/
          }


          var finalS = [];

          if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {

            for (var f in newFilterStatus) {

              var statusOrder = newFilterStatus[f].order;

              if( parseInt(currentStatusOrder) == parseInt(isChecked) ) {
                if( parseInt(statusOrder) > parseInt( isChecked ) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                }
              } else if( parseInt(currentStatusOrder) <= parseInt(isChecked) && parseInt(statusOrder) <= parseInt(isChecked) ) {
                console.log('Two');

                if( parseInt(statusOrder) == parseInt(isChecked) ){
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              } else if( parseInt(currentStatusOrder) >= parseInt(isChecked) && parseInt(statusOrder) >= parseInt(isChecked) ) {
                console.log('Three');
                if( parseInt(statusOrder) == parseInt(isChecked) ){
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              } else {
                console.log('Four');
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
              }
            }
            //return finalS;
          } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') != -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 ) {
            finalS = newFilterStatus;
            //return newFilterStatus;
          } else if( canBack != false || canForward != false ) {
            if( canBack != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 /*&& currentStatusOrder > isChecked*/ ) {
              for (var f in newFilterStatus) {
                if ( parseInt(f) < parseInt(canBack) && parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else if ( parseInt(f) <= parseInt(isChecked) && parseInt(currentStatusOrder) <= parseInt(isChecked)) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else if ( parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 && parseInt(currentStatusOrder) <= parseInt(isChecked)  ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                }
              }
            }
            if( canForward != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {

              for( var f in newFilterStatus ) {
                if( parseInt(f) >= parseInt(canForward) && parseInt(currentStatusOrder) <= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              }
            }
            //return finalS;
          } else {
            finalS = newFilterStatus
            //return newFilterStatus;
          }


        }

        console.log('Final Status');
        console.log( finalS );

        objItem.staticStatus = objItem.status;

        var modalDetails = { title: 'Quote Status Update (' + objItem.quote_no + ')', component: 'modal-quote-status-update', mstate: true, params: {currentStatus: objItem.staticStatus, quoteId: quoteId, currentStatusStatic: objItem.status, object: objItem, statusList: finalS, quoteTotal: objItem.pricing_total } };
        this.$store.dispatch('fncPopulateStatusList');
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

      },
      fncEditStatusPopup() {

        this.$store.dispatch({
          type: 'fncGetLiteStatus',
          data: this.quoteSingle
        })
        //var popupStatuses = this.fncGetStatusDropdown(this.quoteSingle.quote, this.quoteSingle.quote.id);
      },
      fncOpenCalculator() {
        this.$store.dispatch('fncGetCalculators', this.quoteSingle.quote);
      },
      fncUpdateDate( type ){
        if( type == 'manufacturer' ) {

          var sDate = new Date(this.quoteSingle.quote.manufacturer_date_api);
          sDate.setDate(sDate.getDate() + 1);
          var setDate = sDate.toISOString().split('T')[0];

          this.$store.dispatch({
            type: 'fncUpdateDate',
            date: setDate,
            quote_no: this.quoteSingle.quote.id,
            type_action: type
          })
        } else {

          var sDate = new Date(this.quoteSingle.quote.delivery_date_api);
          sDate.setDate(sDate.getDate() + 1);
          var setDate = sDate.toISOString().split('T')[0];

          this.$store.dispatch({
            type: 'fncUpdateDate',
            date: setDate,
            quote_no: this.quoteSingle.quote.id,
            type_action: type
          })
        }
      },
      fncDownloadSurveyDoc() {
        // this.$store.dispatch('fncGetSurveyDocDownload', quoteId)
        this.$store.dispatch({
          type: 'fncGetSurveyDocDownload',
          quoteId: this.quoteSingle.quote.id,
          quoteNo: this.quoteSingle.quote.quote_no,
          users: this.repUsers,
          branches: this.branchList,
          formType: 'full'
        })
      },
      fncEditSurveyDoc() {
        this.$store.dispatch('fncGetSurveyDocEdits', this.quoteSingle.quote.id)
      },
      fncGetSurveyType() {
        if( this.quoteSingle.quote.survey_type == '1' ) {
          return 'Contact Customer';
        } else if( this.quoteSingle.quote.survey_type == '2' ) {
          return 'Request Quote';
        } else if( this.quoteSingle.quote.survey_type == '3' ) {
          return 'Callout Request';
        } else if( this.quoteSingle.quote.survey_type == '4' ) {
          return 'Callout Conversion';
        } else if( this.quoteSingle.quote.survey_type == '5' ) {
          return 'Request Calculator';
        } else {
          return 'N/A';
        }
      },
      fncGetDescription(flag) {
        for( var a in this.quoteSingle.audits ) {
          if( this.quoteSingle.audits[a][flag] == '1' ) {
            if( this.quoteSingle.audits[a].data == '' ) {
              return this.quoteSingle.audits[a].data;
            }
            return 'N/A';
          }
        }
        return 'Not Set';
      },
      fncFormatHtml( formatString ) {
        return formatString.replaceAll(',','<br />');
      },
      fncEditCustomerRecipient() {
        var modalDetails = { title: 'Update Customer Recipient (' + this.quoteSingle.quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'customer', quote: this.quoteSingle.quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncEditVendorRecipient() {
        var modalDetails = { title: 'Update Vendor Recipient (' + this.quoteSingle.quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'vendor', quote: this.quoteSingle.quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncStoreAudits( quote ) {
        var modalDetails = { title: 'Store Code Audits (' + this.quoteSingle.quote.quote_no + ')', component: 'modal-store-audit', mstate: true, params: { quote: this.quoteSingle.quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncUpdateStore() {
        var quote = this.quoteSingle.quoteItems[0];
        quote.store_name = this.quoteSingle.quoteItems[0].code;
        quote.id = this.quoteSingle.quote.id;
        var modalDetails = { title: 'Update Store (' + this.quoteSingle.quote.quote_no + ')', component: 'modal-update-store', mstate: true, params: { quote: this.quoteSingle.quoteItems[0] } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncShowCustomer() {
        this.$store.dispatch('fncGetUserInfo', this.quoteSingle.quote.customer);
        var modalDetails = { title: 'Customer Information - ' + this.quoteSingle.customer.name + ' ' + this.quoteSingle.customer.surname, component: 'modal-user-info', mstate: true, params: { type: 'customer' } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncShowOriginator() {
        this.$store.dispatch('fncGetUserInfo', this.quoteSingle.quote.originator);
        var modalDetails = { title: 'Rep Information - ' + this.quoteSingle.quote.name + ' ' + this.quoteSingle.quote.surname, component: 'modal-user-info', mstate: true, params: { type: 'orig' } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncServiceType() {
        if( this.quoteSingle.quote.service_type == '1' ) {
          return 'Assisted Service';
        } else if( this.quoteSingle.quote.service_type == '2' ) {
          return 'Self Service';
        } else if( this.quoteSingle.quote.service_type == '3' ) {
          return 'Commercial';
        }
        return 'Unknown';
      },
      fncGenerateDeliveryNote() {
        this.$store.dispatch('fncGenerateDeliveryNote', this.quoteSingle.quote);
        /*this.$store.dispatch({
          type: 'fncGenerateDeliveryNote',
          id: this.quoteSingle.quote.id
        })*/
      },
      fncQuoteAttachments(quoteId, quoteNo,item) {

        this.$store.dispatch({
          type: 'fncQuoteSettings',
          quoteId: this.quoteSingle.quote.id,
          quoteNo: this.quoteSingle.quote.quote_no,
          data:this.quoteSingle.quote.id,
        })
      },
      fncNotificationHistory() {

        this.$store.commit('setNotificationHistoryLoaded', false);

        var modalDetails = { title: 'Notification History', component: 'modal-notification-history', mstate: true, params: { quote: this.quoteSingle.quote.id } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

      },
      fncEditQuote( quoteItem ) {

        this.quoteSingle.quote.vendorId = this.quoteSingle.quoteItems[0].vendor_id;
        this.quoteSingle.quote.departmentId = this.quoteSingle.quote.department;
        this.quoteSingle.quote.store_name = this.quoteSingle.quoteItems[0].store_code;

        this.$store.dispatch('fncSetupQuoteEdit', this.quoteSingle.quote);
      },
      fncViewStatusHistory() {
        this.$store.dispatch('fncGetQuoteHistory', this.quoteSingle.quote.id);
        var modalDetails = { title: 'Status History (' + this.quoteSingle.quote.quote_no + ')', component: 'modal-quote-history', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncSetResponsibleReps( setReps, roleId = 0 ) {
        var modalDetails = { title: 'Quote Responsible Reps (' + setReps.quote_no + ')', component: 'modal-set-reps-lite', mstate: true, params: { object: setReps } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncCloneQuote( quoteId, departmentId ) {
        this.$store.dispatch({
          type: 'fncGeQuoteDetails',
          quoteId: this.quoteSingle.quote.id,
          departmentId: this.quoteSingle.quote.department
        });
      },
      fncArchiveQuote() {
        this.$store.dispatch('fncArchiveQuote', this.quoteSingle.quote.id);
      },
      fncViewQuote() {

        this.quoteSingle.quote.departmentId = this.quoteSingle.quote.department;
        this.quoteSingle.quote.quote_date = this.quoteSingle.quote.created;
        this.quoteSingle.quote.originator_name = this.quoteSingle.quote.name + ' ' + this.quoteSingle.quote.surname;
        this.quoteSingle.quote.customer_name = this.quoteSingle.customer[0].name + ' ' + this.quoteSingle.customer[0].surname;

        this.$store.dispatch({
          type: 'fncSetQuoteDetails',
          quoteId: this.quoteSingle.quote.id,
          quote: this.quoteSingle.quote
        });
      },
      fncDownloadQuote() {
        this.$store.dispatch('fncGeneratePdf', this.quoteSingle.quote.id );
      },
      fncApiDetails() {
        var modalDetails = { title: 'API History (' + this.quoteSingle.quote.quote_no + ')', component: 'modal-api-history', mstate: true, params: { quote: this.quoteSingle.quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      }
    },
    beforeMount() {

        this.$store.commit('fncSetQuoteSingle', '');
        this.$store.commit('fncSetQuoteLiteContentLoaded', false);
        this.$store.dispatch('fncFullContent', this.$router.history.current.query.quote);

    },
    mounted() {
    },
    watch: {
      quoteSingle() {
      },
      quoteLiteContentLoaded() {

        document.title = this.quoteSingle.quote.quote_no;

        //this.quoteSingle.quote.vatPrice = ( this.quoteSingle.quote.totalFullPrice / 115 ) * 85;
        this.quoteSingle.quote.vatPrice = this.quoteSingle.quote.totalFullPrice / (1 + (15 / 100));

        this.$store.dispatch('fncPopulateDepartments');
        this.$store.dispatch('fncPopulateBranches');
        this.$store.dispatch('fncPopulateStatusList');
        this.$store.dispatch({
          type: 'fncPopulateUsers',
          context: 0,
          parent: -1,
          notification: 0
        });
      }
    },
    components: {
      DatePicker,
      router
    }
  }
</script>

<style lang="css" scoped src="../../shared/assets/css/bootstrap.min.css"></style>
<style lang="css" scoped src="../../shared/assets/css/lite-style.css"></style>
<style lang="css" scoped src="../../shared/assets/css/fonts.css"></style>
<style lang="css" scoped src="../../shared/assets/css/manu-lite-style.css"></style>


